import React from 'react'
import "./index.css"
import Navbar from './components/Navbar'
import SearchFeed from "./components/SearchFeed"
import VideoDetails from './components/VideoDetails'
import Feed from './components/Feed'
// import { Box } from '@mui/system
import { Box } from '@mui/material'
import ChannelDetail from "./components/ChannelDetail"
import {BrowserRouter, Routes,Route} from "react-router-dom"
const App = () => {
  return (
 <BrowserRouter>
<Box sx={{backgroundColor:"#000"}}>
    <Navbar/>
    <Routes>
        <Route path="/" exact element={<Feed/>}/> 
        <Route path="/video/:id" element={<VideoDetails/>}/>
        <Route path="/channel/:id" element={<ChannelDetail/>}/>
        <Route path="/search/:searchTerm" element={<SearchFeed/>}/>
    </Routes>
</Box>
 </BrowserRouter>
  )
}

export default App
